/* import __COLOCATED_TEMPLATE__ from './mesh-manager.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { dropTask, restartableTask, timeout } from 'ember-concurrency';
import { action } from '@ember/object';
import { mapBy, sortBy } from 'ilios-common/utils/array-helpers';
const DEBOUNCE_TIMEOUT = 250;
const MIN_INPUT = 3;
const SEARCH_RESULTS_PER_PAGE = 50;
let MeshManagerComponent = (_class = class MeshManagerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "query", _descriptor3, this);
    _initializerDefineProperty(this, "searchResults", _descriptor4, this);
    _initializerDefineProperty(this, "searchPage", _descriptor5, this);
    _initializerDefineProperty(this, "hasMoreSearchResults", _descriptor6, this);
    _defineProperty(this, "search", _buildTask(() => ({
      context: this,
      generator: function* () {
        if (this.query.length < MIN_INPUT) {
          this.searchResults = [];
          return; // don't linger around return right away
        }
        yield timeout(DEBOUNCE_TIMEOUT);
        const descriptors = (yield this.store.query('mesh-descriptor', {
          q: this.query,
          limit: SEARCH_RESULTS_PER_PAGE + 1
        })).slice();
        this.searchPage = 1;
        this.hasMoreSearchResults = descriptors.length > SEARCH_RESULTS_PER_PAGE;
        if (this.hasMoreSearchResults) {
          descriptors.pop();
        }
        this.searchResults = descriptors;
      }
    }), null, "search", "restartable"));
    _defineProperty(this, "searchMore", _buildTask(() => ({
      context: this,
      generator: function* () {
        const descriptors = (yield this.store.query('mesh-descriptor', {
          q: this.query,
          limit: SEARCH_RESULTS_PER_PAGE + 1,
          offset: this.searchPage * SEARCH_RESULTS_PER_PAGE
        })).slice();
        this.searchPage = this.searchPage + 1;
        this.hasMoreSearchResults = descriptors.length > SEARCH_RESULTS_PER_PAGE;
        if (this.hasMoreSearchResults) {
          descriptors.pop();
        }
        this.searchResults = [...this.searchResults, ...descriptors];
      }
    }), null, "searchMore", "drop"));
  }
  get terms() {
    return this.args.terms ?? [];
  }
  get hasSearchQuery() {
    return this.query.trim() !== '';
  }
  get sortedTerms() {
    if (!this.terms || this.terms.length === 0) {
      return [];
    }
    return sortBy(this.args.terms, 'name');
  }
  clear() {
    this.searchResults = [];
    this.searchPage = 0;
    this.hasMoreSearchResults = false;
    this.query = '';
  }
  add(term) {
    if (!this.args.editable) {
      return;
    }
    if (mapBy(this.terms, 'id').includes(term.id)) {
      return;
    }
    this.args.add(term);
  }
  keyUp({
    key
  }) {
    if ('Escape' === key) {
      this.clear();
    }
  }
  update(event) {
    this.query = event.target.value;
    this.search.perform();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "query", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "searchPage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasMoreSearchResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _class);
export { MeshManagerComponent as default };